function getTitle(vm) {
  const { title } = vm.$options
  if(title) {
    return typeof title === 'function' ? title.call(vm) : title
  }
}

const metaInfoMixin = {
  metaInfo: {
    meta: [{
      name: 'keywords',
      content: ''
    }],
    link: [{
      rel: 'assets',
      href: ''
    }]
  },
  mounted() {
    const title = getTitle(this)
    if(title) {
      document.title = '虫草官网'
    }
  }
}

export default metaInfoMixin


// WEBPACK FOOTER //
// src/util/meta-info.js